<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-02-17 13:59:59
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterPropertyGroup\newRosterPropertyGroup.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_RosterPropertyGroup_form_newTitle')"
    pad="0"
    widthClass="max-1000"
    :initData="RosterPGData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'roster_property_group_name',
      'roster_property_group_description',
      'roster_property_group_code',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row align="center" justify="start" dense>
              <!-- <v-col  xs='12' sm="12" md='12' lg='12' cols="12">
                <v-switch
                  color="primary"
                  class="ml-4"
                  v-model="RosterPGData.is_default"
                  :label="RosterPGData.is_default ? 'Default' : ''"
                ></v-switch>
              </v-col> -->
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="RosterPGData.roster_property_group_name"
                  maxlength="100"
                  @change="
                    (valueArr) => {
                      RosterPGData.roster_property_group_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_RosterPropertyGroup_form_rosterPropertyGroupNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="RosterPGData.roster_property_group_description"
                  maxlength="500"
                  @change="
                    (valueArr) => {
                      RosterPGData.roster_property_group_description = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_RosterPropertyGroup_form_descriptionLabel')
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  maxlength="100"
                  :label="
                    $t(
                      'label_essweb_RosterPropertyGroup_form_rosterPropertyGroupCodeLabel'
                    )
                  "
                  v-model="RosterPGData.roster_property_group_code"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_RosterPropertyGroup_form_Remark")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  v-model="RosterPGData.remarks"
                  dense
                  counter="500"
                  single-line
                  filled
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <PropertyList
            :items="desserts"
            @edit="toEditProperty"
            :listdata="PropertyListData"
          />
        </template>
      </Stepper>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :newBtn="stepper.length == curStep && curStep != 0 ? true : false"
        :step="stepper.length == curStep ? false : true"
        @next="toNext"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toNew"
        @cancel="$toBack(isChanged)"
      />
    </template>

    <!-- tools -->
    <template v-slot:tools-main>
      <MappingPopup4
        :show="showMappingPopup"
        :PropertyData="PropertyData"
        @close="
          showMappingPopup = false;
          PropertyData = null;
        "
        @confirm="onEditProperty"
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import MappingPopup4 from "@/Page/EssAdmin/Roster/RosterPropertyGroup/components/MappingPopup4";
export default {
  name: "newRosterPG",
  components: { MappingPopup4 },
  computed: {
    ...mapGetters(["companyLang", "defaultUTC"]),
  },
  data() {
    return {
      page: 1,
      isChanged: false,
      changeListArr: [],
      stepper: [
        "label_essweb_RosterPropertyGroup_form_step_generalLabel",
        "label_essweb_RosterPropertyGroup_form_step_propertyGroupLabel",
      ],
      curStep: 1,
      showPGDelete: false,
      PropertyData: null,
      PropertyListData: null,
      showMappingPopup: false,
      RosterPGData: {
        roster_property_group_name: "",
        roster_property_group_description: "",
        roster_property_group_code: "",
        uuid: "",
        remarks: "",
      },
      desserts: [],
    };
  },
  mounted() {
    // this.RosterPGData.roster_property_group_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.RosterPGData.roster_property_group_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getPropertyList();
  },
  methods: {
    getPropertyList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_property",
        url: "/roster-property/get-list/",
        data: {
          roster_property_group_uuid: "",
        },
      }).then((res) => {
        res.data.forEach((item) => {
          item["changeList"] = [];
          if (item.property_master_code.indexOf("|") != -1) {
            item["p_property_master_code"] =
              item.property_master_code.substring(
                0,
                item.property_master_code.lastIndexOf("|")
              );
          }
        });
        that.PropertyListData = res.data;
        that.desserts = that.$translateDataToTree(
          res.data,
          "property_master_code",
          "p_property_master_code"
        );
      });
    },
    onEditProperty: function (obj, x) {
      const that = this;
      this.findTreeItem(
        this.desserts,
        obj.property_master_code,
        obj["changeList"]
      );
      //超过三级刷新数据，不关闭弹窗
      if (x === undefined) this.showMappingPopup = false;
    },
    findTreeItem: function (tree, code, obj) {
      const that = this;
      tree.some((item) => {
        if (item["property_master_code"] === code) {
          item["changeList"] = obj;
          if (item["changeList"].length == 0) {
            item["value"] = "";
          }
          return true;
        } else {
          if (item.children) {
            that.findTreeItem(item.children, code, obj);
          } else {
          }
        }
      });
    },
    findTreeChange: function (tree) {
      const that = this;
      tree.map((item) => {
        if (item["changeList"])
          if (item["changeList"].length) {
            that.changeListArr.push(
              item["changeList"].filter(
                (ele) => ele.effective_utc_datetime !== "" && ele.value !== ""
              )
            );
          }
        if (item.children) {
          that.findTreeChange(item.children);
        }
      });
      that.changeListArr = Array.prototype.concat.apply([], that.changeListArr); // 数组降维
      that.changeListArr.every((it) => {
        if (it["actionid"]) delete it["actionid"];
      });
      return that.changeListArr;
    },
    toEditProperty: function (obj) {
      this.PropertyData = obj;
      this.showMappingPopup = true;
    },
    toNext: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curStep = this.curStep + 1;
    },
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      that.changeListArr = [];
      let arrlist = this.findTreeChange(this.desserts);
      this.$Request({
        method: "POST",
        table: "ess_att_roster_property_group",
        url: "/roster-property-group/add/",
        data: {
          roster_property_group_name: this.$transCommonLangKey(
            this.RosterPGData.roster_property_group_name
          ),
          roster_property_group_description: this.$transCommonLangKey(
            this.RosterPGData.roster_property_group_description
          ),
          roster_property_group_code:
            this.RosterPGData.roster_property_group_code,
          ess_att_roster_property: arrlist,
          remarks: this.RosterPGData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
